import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=7d92f417"
import script from "./PageHeadline.vue?vue&type=script&lang=ts"
export * from "./PageHeadline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports